module.exports = __webpack_public_path__ + "img/checkFailed.8839c93a.png";